// Auto-generated by devextreme-license.
// Do not commit this file to source control.

DevExpress.config({ licenseKey: 'LCPv1eytJpeS3ei:zS_ab2Q@<I7tLSe%z!n,:3%ey%jRXGJzBS_@VI_8Jc+!K(odS3>ek(LFFVjR!9_+p7R<y%Lf@!QF-27XnS7-z,ea3Sj497jt6:<F[7H,Lp+VvSeSn>H3L>%!:,gFKSLFXVRRF%o,VVot!3n)B91mi:j+:!QyQVeS:cKm72NcmkpX;9NX->j!@aQFG%79BIpfB2<F$pLd:6%4$I<fBpLtQ>%X<2p@6p<-)!jyQaNRQpg!F6<4$27y@G<-6p<dQI%!:aQ!)27@QI%4v>jzvaj@Fp<4vpg!$6_yFaj@:>Q4:G_@@9Qdv6<!F6<dFI7yFI7yFI7Ll' });
